import { useNavigate } from "react-router-dom";
import "./Css/TeaccherForm.css";
import { useState, useEffect } from "react";
import axios from "axios";
import API_BASE from "../config/api";

const TeacherForm = () => {
  const navigate = useNavigate();
  const [token, setToken] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [softwares, setSoftwares] = useState([]);
  const [standards, setStandards] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [createdTeacher, setCreatedTeacher] = useState(null);

  const [formData, setFormData] = useState({
    teacherName: "",
    email: "",
    phoneNumber: "",
    softwareIds: [],
    standardIds: [],
    subjectIds: [],
    profilePicture: null,
  });

  useEffect(() => {
    const t = localStorage.getItem("token");
    setToken(t);
  }, []);

  useEffect(() => {
    if (!token) return;

    axios.get(
      `${API_BASE}/api/institute/teachers/dropdowns`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    )
      .then(res => {
        console.log("FULL DROPDOWN RESPONSE:", res.data);
        console.log("SUBJECTS:", res.data.subjects);

        setSoftwares(res.data.softwares || []);
        setStandards(res.data.standards || []);
        setSubjects(res.data.subjects || []);
      });

  }, [token]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectArray = (e, key) => {
    const value = Number(e.target.value);
    if (!value) return;

    setFormData(prev => ({
      ...prev,
      [key]: [value],
    }));
  };

  const handleFileChange = (e) => {
    setFormData({ ...formData, profilePicture: e.target.files[0] });
  };

  const handleSubmit = async () => {
    if (!token) {
      alert("Token missing, please login again");
      return;
    }

    try {
      const data = new FormData();
      data.append("TeacherName", formData.teacherName);
      data.append("Email", formData.email);
      data.append("PhoneNumber", formData.phoneNumber);
      data.append("IsActive", true);

      formData.softwareIds.forEach(id => data.append("SoftwareIds", id));
      formData.standardIds.forEach(id => data.append("StandardIds", id));
      formData.subjectIds.forEach(id => data.append("SubjectIds", id));

      if (formData.profilePicture) {
        data.append("ProfilePicture", formData.profilePicture);
      }

      const res = await axios.post(
        `${API_BASE}/api/institute/teachers`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setCreatedTeacher(res.data);
      setShowPopup(true);

    } catch (error) {
      console.error(error.response?.data || error.message);
      alert(error.response?.data || "Teacher creation failed");
    }
  };
  return (
    <div className="student-page">
      <div className="top-bar">
        <span className="breadcrumb">
          <span
            className="breadcrumb-link"
            onClick={() => navigate("/dashboard")} style={{ cursor: "pointer" }}
          >
            शिक्षक व्यवस्थापन
          </span>
          &nbsp;&gt;&gt;&nbsp;
          <b>नवीन शिक्षक जोडा</b>
        </span>
        <div className="top-buttons">
          <button
            className="btn outline"
            onClick={() => navigate(-1)}
          >
            रद्द करा
          </button>

          <button className="btn primary" onClick={handleSubmit}>
            सेव्ह करा
          </button>
        </div>
      </div>

      <div className="form-card">
        <h2>नवीन शिक्षक जोडा</h2>

        <form className="student-form">
          <div className="form-group">
            <label>शिक्षक नाव</label>
            <input
              type="text"
              name="teacherName"
              placeholder="शिक्षक नाव इथे टाका"
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>ईमेल</label>
            <input
              type="email"
              name="email"
              placeholder="ईमेल इथे टाका"
              onChange={handleChange}
            />
          </div>
          <div className="form-group">
            <label>मोबाईल नं.</label>
            <input
              type="text"
              name="phoneNumber"
              placeholder="मोबाईल नं."
              onChange={handleChange}
            />
          </div>

          <div className="form-group">
            <label>इयत्ता नियुक्त करा	 </label>
            <select onChange={(e) => handleSelectArray(e, "standardIds")}>
              <option value="">इयत्ता निवडा</option>
              {standards.map(s => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>

          </div>
          <div className="form-group">
            <label>परीक्षेचे नाव </label>
            <select onChange={(e) => handleSelectArray(e, "softwareIds")}>
              <option value="">परीक्षेचे नाव</option>
              {softwares.map(s => (
                <option key={s.id} value={s.id}>{s.name}</option>
              ))}
            </select>

          </div>
          <div className="form-group">
            <label>विषय नियुक्त करा</label>
            <select onChange={(e) => handleSelectArray(e, "subjectIds")}>
              <option value="">विषय निवडा</option>

              {subjects.map(sub => (
                <option key={sub.id} value={sub.id}>
                  {sub.name}
                </option>
              ))}
            </select>
          </div>

          <div className="form-group upload-group">
            <label>फोटो अपलोड करा</label>
            <div className="upload-box">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 40 40" fill="none">
                <path d="M19.1673 31.6615H10.834C8.75482 31.6615 6.9851 30.936 5.52482 29.4852C4.06426 28.0344 3.33398 26.2694 3.33398 24.1902C3.33398 22.2799 3.98676 20.5845 5.29232 19.104C6.59787 17.6231 8.22079 16.8281 10.1611 16.719C10.535 14.2917 11.6513 12.2865 13.5102 10.7031C15.3691 9.11979 17.5326 8.32812 20.0007 8.32812C22.7806 8.32812 25.1423 9.29979 27.0856 11.2431C29.029 13.1865 30.0006 15.5481 30.0006 18.3281V19.9948H31.0265C32.6226 20.0462 33.9618 20.6322 35.044 21.7527C36.1262 22.8735 36.6673 24.232 36.6673 25.8281C36.6673 27.4628 36.1037 28.8437 34.9765 29.9706C33.8495 31.0978 32.4687 31.6615 30.834 31.6615H20.834V19.296L24.334 22.7769L25.5136 21.6294L20.0007 16.1165L14.4877 21.6294L15.6673 22.7769L19.1673 19.296V31.6615Z" fill="#2563EB" />
              </svg>
              <input type="file" onChange={handleFileChange} />
              <p>
                <span>अपलोड करण्यासाठी क्लिक करा</span> किंवा फाइल ओढून सोडा
                <br />
                <small>एसव्हीजी, पीएनजी, जेपीजी किंवा जीआयएफ (कमाल आकार: ८००x४०० पिक्सेल)</small>
              </p>
            </div>
          </div>
        </form>
      </div>
      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-card">
            <div className="popup-icon">
              <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 -960 960 960" width="30px" fill="#FFFFFF"><path d="M382-240 154-468l57-57 171 171 367-367 57 57-424 424Z" /></svg>
            </div>

            <h3>
              शिक्षक यशस्वीरित्या जोडले गेले आहेत. !</h3>
            <p>
              नवीन शिक्षकाची नोंदणी पूर्ण झाली आहे.
              <br />
              खाली त्यांचा शिक्षक ID दिलेला आहे.

            </p>

            <div className="student-id">
              शिक्षक ID:  <b>{createdTeacher?.teacherCode}</b>
            </div>
            <button
              className="popup-btn"
              onClick={() => {
                setShowPopup(false);
                navigate(-1);
              }}
            >
              ठीक आहे
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default TeacherForm;